<template>
  <div class="error-page">
    <h1 class="error-page__title">{{ statusCode }}</h1>
    <p class="error-page__message">
      <AppTranslate :identifier="statusMessage" />
    </p>

    <UiButton to="/" class="error-page__button">
      <AppTranslate identifier="common.error.goToHomepage" />
    </UiButton>
  </div>
</template>

<script setup lang="ts">
import { UiButton } from '~/ui';
import { AppTranslate } from '~/infrastructure';

interface Props {
  statusCode?: string;
  statusMessage?: string;
}

withDefaults(defineProps<Props>(), {
  statusCode: '404',
  statusMessage: 'page.404.title',
});
</script>

<style>
.error-page {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 80px 0;
}

.error-page__title {
  font-size: 160px;
  line-height: 160px;
  font-weight: 700;
  color: rgba(var(--v-theme-text-accent));
}

.error-page__message {
  font-size: 24px;
  color: rgba(var(--v-theme-text-accent));
}

.error-page__button {
  margin-top: 32px;
}
</style>
